export default {
  namespaced: true,
  state: {
    questionnaires: []
  },
  getters: {
    questionnaires: state => state.questionnaires,
    getByHallSlug: state => slug => {
      return state.questionnaires.filter(questionnaire => {
        return questionnaire.slug === slug
      })
    },
    findByHallSlug: state => slug => {
      return _.find(state.questionnaires, {slug: slug, isHall: true}) || {}
    },
    findById: state => id => {
      return _.find(state.questionnaires, {questionnaireId: id}) || {}
    }
  },
  mutations: {
    setQuestionnaires(state, questionnaire) {
      if (
        !_(state.questionnaires)
          .filter(q => q.slug === questionnaire.slug && q.questionnaireId === questionnaire.questionnaireId)
          .isEmpty()
      )
        return

      state.questionnaires = _.union(state.questionnaires, [questionnaire])
    },
    removeQuestionnairesById(state, id) {
      state.questionnaires = _.filter(state.questionnaires, function(questionnaire) {
        return questionnaire.questionnaireId !== id
      })
    }
  },
  actions: {
    setQuestionnaires(context, questionnaire) {
      context.commit("setQuestionnaires", questionnaire)
    },
    removeQuestionnairesById(context, id) {
      context.commit("removeQuestionnairesById", id)
    }
  }
}
